import { calculateFontSize } from '../../utils'
import { fontSizes } from './fontSizes'

const pageUrl = window.location.pathname.split('/')[1]
const subPage = window.location.pathname.split('/')[3]

const styles = () => ({
  ckEditorFont: props => ({
    '& .simple-box p:not(.card-header p)': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px 0 8px 0',
      display: 'block ',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 ',
    },
    '&  .ck.ck-editor__editable': {
      padding:
        props.page === 'landing-page'
          ? ' 0 0 48px 0 !important'
          : props.pageReaderSettings &&
            props.pageReaderSettings.textToSpeech.value === true
            ? '84px 0 48px 0 !important'
            : '16px 0 48px 0 !important',
    },
    '& .simple-box': {
      maxWidth:
        props.page === 'page' || props.page === 'completion'
          ? '800px !important' // mini-course 800px
          : pageUrl === 'collection'
            ? '1200px !important' // Collection 1200px
            : props.theme === 0
              ? '1200px !important' // mini-course landing page theme 0 1200px
              : '692px !important', // mini-course landing page theme not 0 692px
    },
    '& .raw-html-embed': {
      maxWidth:
        props.page === 'page' || props.page === 'completion'
          ? '800px !important' // mini-course 800px
          : pageUrl === 'collection'
            ? '1200px !important' // Collection 1200px
            : props.theme === 0
              ? '1200px !important' // mini-course landing page theme 0 1200px
              : '692px !important', // mini-course landing page theme not 0 692px
    },
    '& .simple-box table td .ck-table-bogus-paragraph': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px 0 8px 0',
      display: 'block ',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 !important',
    },
    '& .simple-box table th .ck-table-bogus-paragraph': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      display: 'block ',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: 'bold !important',
    },
    '& .simple-box .table th p': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '0 !important',
      display: 'block ',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: 'bold !important',
    },

    '& .simple-box ul': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px 0 8px 0',
      display: 'block ',
      margin: '0',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 !important',
      marginLeft: '20px',
    },
    '& .simple-box .pixel-quest': {

      fontFamily: props.fontFamily || 'Inter !important',

    },

    '& .simple-box li': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px 0 8px 0',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 !important',
    },
    '& .simple-box .crossword-puzzle-widget-container ul, & .simple-box .crossword-puzzle-widget-container ol': {
      marginLeft: '0 !important',
      margin: '0 !important',
    },
    '& .simple-box .table td p': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px',
      display: 'block ',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 !important',
    },
    // The catalog block renders spans, inputs and labels that none of the element-specific
    // rules below reach, so they would fall back to the browser default instead of the
    // collection's font.
    '& .simple-box .catalog-wrapper, & .simple-box .catalog-wrapper span, & .simple-box .catalog-wrapper input, & .simple-box .catalog-wrapper .label': {
      fontFamily: props.fontFamily ? props.fontFamily : 'Inter !important',
    },
    '& .simple-box h1': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.h1, props.fontSize)
        : fontSizes.h1,
      padding: '8px 0 8px 0 !important',
      fontFamily: props.fontFamily ? props.fontFamily : 'Inter !important',
      lineHeight: '44px',
      fontWeight: '600 !important',
      margin: '0 !important',
    },
    '& .simple-box h2': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.h2, props.fontSize)
        : fontSizes.h2,
      padding: '8px 0 8px 0',
      fontFamily: props.fontFamily ? props.fontFamily : 'Inter !important',
      lineHeight: '36px',
      fontWeight: '500 !important',
      margin: '0 !important',
    },
    '& .simple-box h3': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.h3, props.fontSize)
        : fontSizes.h3,
      padding: '8px 0 8px 0 !important',
      fontFamily: props.fontFamily ? props.fontFamily : 'Inter !important',
      lineHeight: '32px',
      fontWeight: '500 !important',
      margin: '0 !important',
    },
    '& .simple-box .tts-button': {
      display: 'inline-block',
      marginLeft: 8,
      verticalAlign: 'middle',
      cursor: 'pointer',
    },
  }),
})

export default styles
